// extracted by mini-css-extract-plugin
export var actions = "_8c-8";
export var arrow = "_8c-5";
export var card = "_8c-0";
export var cardWrapper = "_8c-9";
export var fieldName = "_8c-3";
export var newValue = "_8c-6";
export var oldValue = "_8c-4";
export var orangeGlowFade = "_8c-c";
export var productSection = "_8c-1";
export var scrollToBottom = "_8c-b";
export var scrollToBottomAnchor = "_8c-a";
export var scrollToBottomIcon = "_8c-d";
export var showAllButton = "_8c-7";
export var table = "_8c-2";